import {observer} from 'mobx-react';
import {Layout} from 'shared/components';
import {TimeTrackingSubnav} from 'main/containers/time_tracking';
import DimensionDirectory from './DimensionDirectory';

const DimensionsContainer = observer(({scope}) => {
  return (
    <div>
      <TimeTrackingSubnav scope={scope}/>
      <Layout>
        <DimensionDirectory/>
      </Layout>
    </div>
  );
});

export default DimensionsContainer;
